"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Edit = function Edit(props) {
  return _react2["default"].createElement("svg", (0, _extends3["default"])({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12"
  }, props), _react2["default"].createElement("path", {
    d: "M8.824.176l3 3a.6.6 0 0 1 0 .848l-7.8 7.8A.6.6 0 0 1 3.6 12h-3a.6.6 0 0 1-.6-.6v-3a.6.6 0 0 1 .176-.424l7.8-7.8a.6.6 0 0 1 .848 0z",
    className: "fill"
  }));
};

exports["default"] = Edit;